// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--10-1!../../node_modules/postcss-loader/lib/index.js??ref--10-2!../../node_modules/sass-loader/dist/cjs.js??ref--10-3!./main.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("69b0c60b", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.scss
// module id = 67t3
// module chunks = 71